<template>

<div class="section-container">

  <div id="slide02" class="section">

    <Fimage name="logo-small.svg"/>

    <carousel
      :per-page="1"
      pagination-active-color="#ffffff"
      pagination-color="#030104"
      pagination-position="bottom-overlay"
      @page-change="handlePageChange">

      <slide>
        <S02Section01/>
      </slide>

      <slide>
        <S02Section02/>
      </slide>

      <slide>
        <S02Section03/>
      </slide>

    </carousel>

  </div>

</div>

</template>

<script>
import $ from 'jquery'
import { Carousel, Slide } from 'vue-carousel';
import Fimage from '../general/elements/Fimage.vue'
import S02Section01 from './section02/S02Section01.vue'
import S02Section02 from './section02/S02Section02.vue'
import S02Section03 from './section02/S02Section03.vue'

export default {
  name: 'Slide02',
  components: {
    Carousel,
    Slide,
    Fimage,
    S02Section01,
    S02Section02,
    S02Section03
  },
  methods: {
    handlePageChange: function() {
      $('html, body').animate({
        scrollTop: $('#slide02').offset().top
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .VueCarousel-slide {
  padding: 0 1px !important;
}

::v-deep .VueCarousel-dot-container {
  float: right !important;
  margin: 0 !important;
}

::v-deep .VueCarousel-dot {
  border: 1px solid #ffffff !important;
  padding: 0 !important;
  margin: 0 10px !important;

  &:focus {
    outline: 0 !important;
  }
}
</style>
